import {cx} from "@emotion/css";
import {Stack, Box, useMediaQuery} from "@mui/material";

import {BmPageSubtitle, BmPageTitle} from "~/components/titles";
import {LayoutType, PageContentVariant} from "~/layouts/pageContents/types";
import {IBreadcrumbItem, BmBreadcrumbs} from "~/components/breadcrumbs";
import {theme} from "~/ui/theme";
import {BmArrowLeftIcon} from "~/components/icons/simpleIcons";

import {styles} from "./ContentHeader.styles";

interface ContentHeaderProps extends LayoutType {
  variant: PageContentVariant;
  breadcrumbs?: IBreadcrumbItem[];
  isArrow?: boolean;
  onArrowClick?: VoidFunction;
}

export const ContentHeader: React.FC<ContentHeaderProps> = ({
  className,
  variant,
  breadcrumbs,
  title,
  subtitle,
  statusLabel,
  headerButtons,
  isArrow,
  onArrowClick,
}) => {
  const isGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box component="header" className={cx(styles.root(variant), className)}>
      {!!breadcrumbs && (
        <Box mb={2}>
          <BmBreadcrumbs breadcrumbs={breadcrumbs} />
        </Box>
      )}
      <Stack
        flexDirection="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={2}
        useFlexGap
        sx={{
          mb: subtitle ? 2 : 0,
          [theme.breakpoints.up("md")]: {
            alignItems: "center",
            flexDirection: "row",
          },
        }}
      >
        <Stack spacing={2} direction="row" alignItems="center" useFlexGap>
          {isArrow && (
            <Box onClick={onArrowClick} sx={{cursor: "pointer"}}>
              <BmArrowLeftIcon id={"arrow-left-icon"} />
            </Box>
          )}
          <BmPageTitle sx={{mb: 0}}>{title}</BmPageTitle>
          {statusLabel}
        </Stack>

        {headerButtons && (
          <Stack direction={isGreaterThanMd ? "row" : "column"} spacing={1} useFlexGap>
            {headerButtons}
          </Stack>
        )}
      </Stack>

      {subtitle && <BmPageSubtitle>{subtitle}</BmPageSubtitle>}
    </Box>
  );
};
